import { AutoCompleteDataModel, AutoCompleteSuggestions, MprcAutoComplete } from "components/MprcAutoComplete";
import { IAutoCompleteProps } from "components/MprcAutoComplete/AutoComplete";

////////////////////////////////////////////////////////////////////////////

interface IProps {
    selectionList: string[] | null;
}

type Props = IProps & Omit<IAutoCompleteProps, 'onGetSuggestions' | 'emptyThumbnail'>;

////////////////////////////////////////////////////////////////////////////

/**
 * Auto complete de grupos para cadastros
 * @param props
 */
export const CustomFieldSelectValueAutoComplete: React.FC<Props> = (props) => {

    const { selectionList } = props;

    ///
    const getValueSelectionSuggestions = (
        searchText: string,
        pageNumber: number,
        pageSize: number
    ): Promise<AutoCompleteSuggestions<AutoCompleteDataModel>> => {
        searchText = searchText.toLowerCase();
        return new Promise<AutoCompleteSuggestions<AutoCompleteDataModel>>((resolve) => {
            let items = [] as AutoCompleteDataModel[];

            if (selectionList !== undefined) {
                items = selectionList!.filter((x) => x.includes(searchText))
                    .map((x) => ({ key: x, label: x, canDelete: true } as AutoCompleteDataModel));
            }
            resolve({ items, totalRows: items.length });
        });
    };

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <MprcAutoComplete
            {...props}
            fullWidth
            onGetSuggestions={getValueSelectionSuggestions}
        />
    );
};
